import {useState } from "react";
import {Dropzone, DropzoneProps, IMAGE_MIME_TYPE} from "@mantine/dropzone";
import {Group, rem, Text, useMantineTheme,Image, ActionIcon, Modal,} from "@mantine/core";
import {IconUpload, IconX,IconZoomIn, IconTrash} from "@tabler/icons-react";


interface IFileInputProps extends Pick<DropzoneProps, 'multiple'> {
    label: string;
    description: string;
    multiple?: boolean;
    onDrop: (files: File[]) => void;
}

const FileDropzone = ({ label, description, onDrop, ...others }: IFileInputProps) => {
    const theme = useMantineTheme();
    const [preview, setPreview] = useState<string | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleFileDrop = (files: File[]) => {
        if (files.length > 0) {
            const file = files[0];
            setSelectedFile(file);
            setPreview(URL.createObjectURL(file));
            onDrop(files);
        }
    };

    const removeImage = () => {
        selectedFile
        setSelectedFile(null);
        setPreview(null);
    };

    return (
        <div>
            {preview ? (
                <div style={{ position: 'relative', display: 'inline-block', maxWidth: '200px' }}>
                    <Image
                        src={preview}
                        alt="Uploaded preview"
                        style={{ borderRadius: '8px', cursor: 'pointer' }}
                        onClick={() => setIsModalOpen(true)}
                    />
                    <ActionIcon
                        color="red"
                        size="lg"
                        style={{ position: 'absolute', top: 5, right: 5 ,backgroundColor:"amber"}}
                        onClick={removeImage}
                    >
                        <IconTrash size="1.3rem" />
                    </ActionIcon>
                    <ActionIcon
                        color="blue"
                        size="lg"
                        style={{ position: 'absolute', bottom: 5, right: 5 ,backgroundColor:"oranger"}}
                        onClick={() => setIsModalOpen(true)}
                    >
                        <IconZoomIn size="1.3rem" />
                    </ActionIcon>
                </div>
            ) : (
                <Dropzone
                    onDrop={handleFileDrop}
                    onReject={(files) => console.log('Rejected files', files)}
                    maxSize={5 * 1024 ** 2}
                    accept={IMAGE_MIME_TYPE}
                    {...others}
                >
                    <Group
                        position="center"
                        spacing="xl"
                        style={{ minHeight: rem(120), pointerEvents: 'none' }}
                    >
                        <Dropzone.Accept>
                            <IconUpload size="3.2rem" stroke={1.5} color={theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]} />
                        </Dropzone.Accept>
                        <Dropzone.Reject>
                            <IconX size="3.2rem" stroke={1.5} color={theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]} />
                        </Dropzone.Reject>
                        <Dropzone.Idle>
                            <IconUpload size="3.2rem" stroke={1.5} />
                        </Dropzone.Idle>

                        <div>
                            <Text size="xl" inline>
                                {label || 'Upload your campaign picture (No more than 5MB)'}
                            </Text>
                            <Text size="sm" color="dimmed" inline mt={7}>
                                {description || 'This picture will be shown in campaign listing'}
                            </Text>
                        </div>
                    </Group>
                </Dropzone>
            )}

            {/* Modal for Zoomed Image */}
            <Modal opened={isModalOpen} onClose={() => setIsModalOpen(false)} size="lg" title="Image Preview">
                <Image src={preview || ''} alt="Zoomed Preview" />
            </Modal>
        </div>
    );
};

export default FileDropzone;
